<template>
  <div class="app-container">
    <nav-bar class="app-content-header"></nav-bar>
    <div class="app-content">
      <side-bar class="app-sidebar"></side-bar>
      <app-main class="app-content-content"></app-main>
    </div>
  </div>
</template>

<script>
  import NavBar from './navbar'
  import SideBar from './sidebar'
  import AppMain from './appMain'

  export default {
    name: 'layout',
    data() {
      return {}
    },
    components: {
      NavBar,
      SideBar,
      AppMain
    },
    methods: {},
    mounted() {}
  }
</script>

<style lang="scss">
  body{
    font-family: "Avenir",PingFang SC,Arial,Helvetica,STHeiti STXihei,"Microsoft YaHei",Tohoma,sans-serif!important;
    background-color: #f0f1f3!important;
  };
  .app-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    .app-content-header{
      height: $headerHeight;
      line-height: $headerHeight;
      color: $mainColor;
      background-color: #fff;
      position: sticky;
      top: 0;
      z-index: 999;
    }

    .app-content {
      display: flex;
      flex: 1;
      .app-sidebar {
        height: 100%;
        // max-width: 200px;
        width: auto;
      }
      .app-content-content{
        flex: 1;
        padding-top: 1px;
        box-sizing: border-box;
      }
      overflow-x: hidden;

    }

    .app-footer {
      text-align: center;
      line-height: 60px;
    }
  }

</style>
